module.exports = __webpack_public_path__ + "ca316028bb14e0aab85c761d69c97d66.jpg";